
import React from 'react';
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { VERSION } from '@/utils/version';

export function VersionBadge() {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge variant="outline" className="bg-[#05445e] text-white hover:bg-[#189ab4]">
            v{VERSION.number}
          </Badge>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">
          <div className="space-y-1">
            <p className="font-semibold">{VERSION.name}</p>
            <p className="text-xs">Lançado em: {VERSION.releaseDate}</p>
            <p className="text-xs">{VERSION.notes}</p>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
